import { withFormik } from 'formik';
import Yup from 'yup';

import FormModal from 'buyside/components/presentation/Form/FormModal/formModal';

const FundProfileFormModalContainer = withFormik({
  mapPropsToValues: ({ fundProfile }) => ({
    fundProfile,
    submitDetector: null
  }),
  validationSchema: ({ validationSchema }) => validationSchema || Yup.object(),
  handleSubmit: (
    { fundProfile },
    { props: { update, closeModal }, resetForm, setStatus, setSubmitting }
  ) => {
    update({ fundProfile })
      .then(() => {
        closeModal();
        setTimeout(resetForm, 500);
      })
      .catch(() => {
        setStatus({ serverError: true });
        setSubmitting(false);
      });
  },
  enableReinitialize: true
})(FormModal);

export default FundProfileFormModalContainer;
